import { useInjection } from "@linkfluence/core/di";
import { useMutation } from "@tanstack/react-query";
import { DiscoveryFeedback } from "@radarly/models/discovery";
import { InsightPage } from "@radarly/models/insight-pages/model";
import { Project } from "@radarly/models/project";
import { Workspace } from "@radarly/models/workspace";
import {
  InsightPageRepo,
  InsightPageRepositoryUID,
} from "../repositories/InsightPageRepo";

type DataProps = {
  projectId: Project["id"];
  workspaceId: Workspace["id"];
  page: InsightPage;
  discoveryFeedback: DiscoveryFeedback;
};

export function useDiscoverySendFeedback() {
  const repository = useInjection<InsightPageRepo>(InsightPageRepositoryUID);

  const { mutateAsync, isLoading } = useMutation(
    ({ projectId, workspaceId, page, discoveryFeedback }: DataProps) => {
      if (discoveryFeedback.feedback === true) {
        return repository.sendDiscoveryFeedback(
          projectId,
          workspaceId,
          page,
          true,
          undefined,
          ""
        );
      } else {
        return repository.sendDiscoveryFeedback(
          projectId,
          workspaceId,
          page,
          false,
          discoveryFeedback.reason,
          discoveryFeedback.message ?? ""
        );
      }
    }
  );

  const sendFeedback = async (
    projectId: Project["id"],
    workspaceId: Workspace["id"],
    page: InsightPage,
    discoveryFeedback: DiscoveryFeedback
  ) => {
    await mutateAsync({ projectId, workspaceId, page, discoveryFeedback });
  };

  return {
    sendFeedback,
    isLoading,
  };
}
